import nextPrevBackground from '../../../assets/js/_next-prev-background.js';

function callToAction( nodes = '.cta', settings = {} ) {
	if ( typeof nodes === 'string' ) {
		nodes = Array.from( document.querySelectorAll( nodes ) );
	} else if ( nodes instanceof HTMLElement ) {
		nodes = [ nodes ];
	}

	if ( nodes && nodes.length ) {
		nodes.forEach( nextPrevBackground );
	}

	return nodes;
}

document.addEventListener( 'DOMContentLoaded', () => callToAction() );

export default callToAction;
